<h2>Representatives <button class="icon--add btn--default" type="button" (click)="addRepresentative()" *ngIf="canEdit">Add Representative</button><button class="icon--history btn--default" type="button" (click)="showHistory(customerNumber)">View History</button></h2>
<p-table [value]="representatives" [columns]="cols">
    <ng-template pTemplate="header" let-columns>
        <tr>
            <th *ngFor="let col of columns" [pSortableColumn]="col.field">{{col.header}}<p-sortIcon [field]="col.field"></p-sortIcon></th>
            <th class="w--icon">Edit</th>
        </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
        <tr>
            <td [attr.colspan]="6">
                No records found
            </td>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-columns="columns" let-data>
        <tr>
            <td>{{data.firstName + " " + data.lastName}}</td>
            <td>{{data.cellPhone}}</td>
            <td class="td--hover-show">{{data.email}}</td>
            <td>{{data.effectiveDate | shortDate}}</td>
            <td>{{data.endDate | shortDate}}</td>
            <td class="text-center"><a class="icon--edit" title="Edit Representative" href="javascript:void(0);" (click)="editRepresentative(data.id)"></a></td>
        </tr>
    </ng-template>
</p-table>
